import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
import Select from "react-select";

import DateTimePickerComponent from "../../common/DateTimePicker";
import { Select2Data } from "../../../utils/common";
import { getData } from "../../../utils/api";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [imageFile, setImageFile] = useState(null);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [galleryPreviews, setGalleryPreviews] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
  } = useForm();

  // Watch the start date field
  const startDate = watch("start_date");

  // Custom validation function for end date
  const validateEndDate = (endDate) => {
    if (!endDate) {
      return "End Date is required";
    }
    if (new Date(endDate) < new Date(startDate)) {
      return "End Date cannot be before Start Date";
    }
    return true;
  };



  const onSubmit = async (data) => {
  
    try {

      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("ratings", data?.ratings);
      sendData.append("review", data?.review);
      sendData.append("product_id", data?.product_id?.value);


      sendData.append("imageCount", galleryImages.length);
      galleryImages.forEach((file, i) => {
        sendData.append(`image${i}`, file);
      });
      const response = await postData(`/admin/products/rating`, sendData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };



  const getAllProducts = async () => {
    const response = await getData(`/common/masters/product`);
    if (response?.success) {
      setProducts(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    getAllProducts();
  }, []);

  const productOptions = products?.map((item) => ({
    value: item?.id,
    label: item?.name,
    image: item?.image,
  }));

  const handleProductChange = (selected) => {
    setSelectedProduct(selected);

    setValue("product_id", selected);

   
  };

  const handleGalleryChange = (e) => {
    const files = Array.from(e.target.files || []);
    setGalleryImages(files);
    const previews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setGalleryPreviews(previews);
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile([file]);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    } else {
      setImageFile(null);
    }
  };


  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Sale</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Name"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Product</Form.Label>

                    <Controller
                      name="product_id"
                      control={control}
                      rules={{
                        required: "Product is required",
                      }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={products}
                          placeholder="Select Product"
                          isClearable
                          onChange={(selected) => {
                            field.onChange(selected);
                            handleProductChange(selected);
                          }}
                        />
                      )}
                    />

                    {errors?.product_id && (
                      <span className="text-danger">
                        {errors.product_id.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>



              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Product Image</Form.Label>

                    <div
                      className="border rounded p-2 d-flex align-items-center justify-content-center"
                      style={{
                        minHeight: "150px",
                        background: "#f8f9fa",
                      }}
                    >
                      {selectedProduct?.image ? (
                        <img
                          src={selectedProduct.image}
                          alt={selectedProduct?.label}
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <span className="text-muted">
                          Select a product to view image
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </div>
              </Col> */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div>
                      <Form.Label>Rating</Form.Label>
                    </div>

                    <InputGroup>
                      <Form.Control
                        type="number"
                        name="ratings"
                        placeholder="Rating"
                        min="1"
                        max="5"
                        step="1"
                        className={classNames("", {
                          "is-invalid": errors?.ratings,
                        })}
                        {...register("ratings", {
                          required: "Rating is required",
                          valueAsNumber: true,
                          min: {
                            value: 1,
                            message: "Rating must be between 1 and 5",
                          },
                          max: {
                            value: 5,
                            message: "Rating must be between 1 and 5",
                          },
                          validate: (value) => {
                            if (!Number.isInteger(value)) {
                              return "Rating must be a whole number";
                            }
                            return true;
                          },
                        })}
                      />
                    </InputGroup>

                    {errors.ratings && (
                      <span className="text-danger">
                        {errors.ratings.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              {/* <DateTimePickerComponent
                      setValue={setValue}
                      name={"start_date"}
                      errors={errors}
                      register={register}
                    /> */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Review</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="review"
                        placeholder="Start Date"
                        className={classNames("", {
                          "is-invalid": errors?.review,
                        })}
                        {...register("review", {
                          required: "Start Date is required",
                        })}
                      />
                    </InputGroup>

                    {errors.review && (
                      <span className="text-danger">
                        {errors.review.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Gallery Images</Form.Label>

                    <Form.Control
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleGalleryChange}
                    />

                    <small className="text-muted">
                      You can select multiple images.
                    </small>

                    {/* Gallery Preview */}
                    {galleryPreviews?.length > 0 && (
                      <div className="d-flex flex-wrap gap-3 mt-3">
                        {galleryPreviews.map((item, index) => (
                          <div
                            key={index}
                            style={{
                              position: "relative",
                              width: "100px",
                              height: "100px",
                            }}
                          >
                            <img
                              src={item.preview}
                              alt={`Gallery ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "6px",
                                border: "1px solid #ddd",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </Form.Group>
                </div>
              </Col>



              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
